import React, { useState, useEffect,useContext } from 'react';
import { createUnits, updateUnits } from '../../../Utility/Api'; 
import { toast } from 'react-toastify';
import { WarehouseContext } from '../../../Utility/UserContext';


const UnitsForm = ({ unit, closeModal, refreshList }) => {
  const [formData, setFormData] = useState({
    title: '',  
  });
  const [errors, setErrors] = useState({});
  const { showLoader, hideLoader,shopItem,UserItem } = useContext(WarehouseContext);

  useEffect(() => {
    if (unit) {
      setFormData({
        title: unit.title, 
      });
    }
  }, [unit]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "title") {
      // Only alphabets and spaces
      if (!/^[A-Za-z\s]*$/.test(value)) return;
    }

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "", 
    }));
  };

  const handleSubmit = async (e) => {
    showLoader()
    e.preventDefault();

    if (!formData.title) {
      toast.error('Title is required');
      return;
    }

    const formDataPayload = new FormData();
    formDataPayload.append('title', formData.title);
    formDataPayload.append('shop_id', shopItem?.shop_id);
    formDataPayload.append('created_by', UserItem?.user_id);

    try {
      if (unit) {
        await updateUnits(unit.id, formDataPayload);
        hideLoader()  
        toast.success('Unit updated successfully');
      } else {
        await createUnits(formDataPayload);  
        hideLoader()
        toast.success('Unit added successfully');
      }
      closeModal();
      hideLoader()
      refreshList();
    } catch (error) {
      console.error('Error saving unit data:', error);
      hideLoader()
      toast.error(error.response?.data?.message || "Error");
    }
  };

  return (
    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" style={{ fontFamily: 'poppins' }}>
              {unit ? 'Edit Unit' : 'Add Unit'}
            </h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
          </div>
          <div className="modal-body" style={{ fontFamily: 'poppins' }}>
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <label>Title</label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
                {errors.title && <small className="text-danger">{errors.title}</small>}
              </div>

              <button type="submit" className="btn btn-success float-end">
                {unit ? 'Update Unit' : 'Add Unit'}
              </button>
              <button
                type="button"
                className="btn btn-secondary ml-2 float-end me-1"
                onClick={closeModal}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitsForm;
